import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';

import { TranslateModule } from '@ngx-translate/core';

import { FuseNavigationComponent } from './navigation.component';
import { FuseNavVerticalItemComponent } from './vertical/item/item.component';
import { FuseNavVerticalCollapsableComponent } from './vertical/collapsable/collapsable.component';
import { FuseNavVerticalGroupComponent } from './vertical/group/group.component';
import { FuseNavHorizontalItemComponent } from './horizontal/item/item.component';
import { FuseNavHorizontalCollapsableComponent } from './horizontal/collapsable/collapsable.component';
import { ItemActiveIfAnyChildIsActiveDirective } from './directives/item-active-if-any-child-is-active.directive';
import { CoreModule } from '../../../app/core/core.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,

    MatIconModule,

    TranslateModule.forChild(),
    CoreModule
  ],
  exports: [
    FuseNavigationComponent,
    ItemActiveIfAnyChildIsActiveDirective
  ],
  declarations: [
    FuseNavigationComponent,
    FuseNavVerticalGroupComponent,
    FuseNavVerticalItemComponent,
    FuseNavVerticalCollapsableComponent,
    FuseNavHorizontalItemComponent,
    FuseNavHorizontalCollapsableComponent,
    ItemActiveIfAnyChildIsActiveDirective
  ]
})
export class FuseNavigationModule {
}
